import * as React from "react";
const SvgPowerBi = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#PowerBi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#PowerBi_svg__b)",
  d: "M18.715 2h-5.302a.825.825 0 0 0-.825.825v18.35c0 .456.37.825.825.825h5.302c.456 0 .825-.37.825-.825V2.825A.825.825 0 0 0 18.715 2"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#PowerBi_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.445 21.175V22H9.318a.825.825 0 0 1-.825-.825V7.81c0-.456.37-.826.825-.826h5.302c.456 0 .825.37.825.826z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#PowerBi_svg__d)",
  d: "M15.445 21.175V22H9.318a.825.825 0 0 1-.825-.825V7.81c0-.456.37-.826.825-.826h5.302c.456 0 .825.37.825.826z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#PowerBi_svg__e)",
  fillRule: "evenodd",
  d: "M11.413 21.175V22H5.286a.825.825 0 0 1-.825-.825v-8.35c0-.455.37-.825.825-.825h5.302c.456 0 .825.37.825.825z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "PowerBi_svg__b",
  x1: 16.064,
  x2: 16.064,
  y1: 2,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBBB14"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B25400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PowerBi_svg__d",
  x1: 11.969,
  x2: 11.969,
  y1: 6.984,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9E583"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DE9800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PowerBi_svg__e",
  x1: 7.937,
  x2: 7.937,
  y1: 12,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9E68B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3CD32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "PowerBi_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h20v20H2z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "PowerBi_svg__c",
  width: 8.222,
  height: 16.286,
  x: 8.493,
  y: 6.667,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.635,
  dy: 0.317
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.317
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0530212 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2594_162"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2594_162",
  result: "shape"
}))));
export default SvgPowerBi;
//# sourceMappingURL=PowerBi.js.map